var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "core-js/modules/es6.regexp.to-string", "core-js/modules/es6.date.to-string", "core-js/modules/es6.object.to-string", "@babel/runtime-corejs2/core-js/reflect/construct", "core-js/modules/es6.regexp.search", "@babel/runtime-corejs2/helpers/extends", "@babel/runtime-corejs2/helpers/classCallCheck", "@babel/runtime-corejs2/helpers/createClass", "@babel/runtime-corejs2/helpers/assertThisInitialized", "@babel/runtime-corejs2/helpers/inherits", "@babel/runtime-corejs2/helpers/possibleConstructorReturn", "@babel/runtime-corejs2/helpers/getPrototypeOf", "@babel/runtime-corejs2/helpers/defineProperty", "react", "prop-types", "classnames"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("core-js/modules/es6.regexp.to-string"), require("core-js/modules/es6.date.to-string"), require("core-js/modules/es6.object.to-string"), require("@babel/runtime-corejs2/core-js/reflect/construct"), require("core-js/modules/es6.regexp.search"), require("@babel/runtime-corejs2/helpers/extends"), require("@babel/runtime-corejs2/helpers/classCallCheck"), require("@babel/runtime-corejs2/helpers/createClass"), require("@babel/runtime-corejs2/helpers/assertThisInitialized"), require("@babel/runtime-corejs2/helpers/inherits"), require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"), require("@babel/runtime-corejs2/helpers/getPrototypeOf"), require("@babel/runtime-corejs2/helpers/defineProperty"), require("react"), require("prop-types"), require("classnames"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.es6Regexp, global.es6Date, global.es6Object, global.construct, global.es6Regexp, global._extends, global.classCallCheck, global.createClass, global.assertThisInitialized, global.inherits, global.possibleConstructorReturn, global.getPrototypeOf, global.defineProperty, global.react, global.propTypes, global.classnames);
    global.SearchForm = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _es6Regexp, _es6Date, _es6Object, _construct, _es6Regexp2, _extends2, _classCallCheck2, _createClass2, _assertThisInitialized2, _inherits2, _possibleConstructorReturn2, _getPrototypeOf2, _defineProperty2, _react, _propTypes, _classnames) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _construct = _interopRequireDefault(_construct);
  _extends2 = _interopRequireDefault(_extends2);
  _classCallCheck2 = _interopRequireDefault(_classCallCheck2);
  _createClass2 = _interopRequireDefault(_createClass2);
  _assertThisInitialized2 = _interopRequireDefault(_assertThisInitialized2);
  _inherits2 = _interopRequireDefault(_inherits2);
  _possibleConstructorReturn2 = _interopRequireDefault(_possibleConstructorReturn2);
  _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf2);
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _react = _interopRequireWildcard(_react);
  _propTypes = _interopRequireDefault(_propTypes);
  _classnames = _interopRequireDefault(_classnames);

  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

  var SearchForm = /*#__PURE__*/function (_PureComponent) {
    (0, _inherits2.default)(SearchForm, _PureComponent);

    var _super = _createSuper(SearchForm);

    function SearchForm() {
      var _this;

      (0, _classCallCheck2.default)(this, SearchForm);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSubmit", function (event) {
        // if searchForm is a function, we don't submit the form
        // but we call the callback function with the keyword as first parameter
        if (_this.props.searchForm.callback && typeof _this.props.searchForm.callback === 'function') {
          event.preventDefault();

          _this.props.searchForm.callback.call((0, _assertThisInitialized2.default)(_this), _this.domElement.value);
        }
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "init", function (domElement) {
        _this.domElement = domElement;
      });
      return _this;
    }

    (0, _createClass2.default)(SearchForm, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            labels = _this$props.labels,
            searchIsOpen = _this$props.searchIsOpen;
        var ariaFormProps = {
          'aria-hidden': searchIsOpen ? 'false' : 'true',
          tabIndex: searchIsOpen ? 0 : -1
        };
        var ariaInputProps = {
          'aria-label': labels.input,
          'aria-hidden': searchIsOpen ? 'false' : 'true',
          tabIndex: searchIsOpen ? 0 : -1
        };
        var ariaSubmitProps = {
          'aria-label': labels.submit,
          'aria-hidden': searchIsOpen ? 'false' : 'true',
          tabIndex: searchIsOpen ? 0 : -1
        };
        return /*#__PURE__*/_react.default.createElement("form", (0, _extends2.default)({}, ariaFormProps, {
          method: "get",
          className: (0, _classnames.default)('next-menu__form', {
            'is-open': this.props.searchIsOpen
          }),
          onSubmit: this.onSubmit
        }), /*#__PURE__*/_react.default.createElement("input", (0, _extends2.default)({}, ariaInputProps, {
          ref: this.init,
          type: "search",
          name: "q",
          placeholder: this.props.searchForm.placeholder,
          className: "next-menu__input"
        })), /*#__PURE__*/_react.default.createElement("button", (0, _extends2.default)({}, ariaSubmitProps, {
          type: "submit",
          className: "next-menu__submit search search--search"
        }), labels.search));
      }
    }]);
    return SearchForm;
  }(_react.PureComponent);

  SearchForm.propTypes = {
    labels: _propTypes.default.shape({
      input: _propTypes.default.string,
      submit: _propTypes.default.string,
      search: _propTypes.default.string
    }),
    searchForm: _propTypes.default.shape({
      callback: _propTypes.default.func,
      placeholder: _propTypes.default.string
    }).isRequired,
    searchIsOpen: _propTypes.default.bool.isRequired
  };
  SearchForm.defaultProps = {
    labels: {
      input: 'mot clé à rechercher',
      submit: 'lancer la recherche',
      search: 'chercher'
    },
    searchForm: {
      placeholder: 'Rechercher'
    }
  };
  var _default = SearchForm;
  _exports.default = _default;
});